import React from 'react'
import './Projects.css'
import Project from './Project';
import { allProjects } from './allProjectsList';

function Projects() {
  return (
    <div>
      <div className="header-text-h1">
        <h1 className='header-text'>Projects</h1>
      </div>
      <div className='container mt-5 mx-auto'>
        {
          allProjects.map((project) => {
            return <Project key={project.title} currentProject={project} />
          }
          )
        }
      </div>
    </div>
  )
}

export default Projects